<template>
  <div class="p-box-wrap" :class="className" id="box-status">
    <div class="p-box-status">
      <div class="col-md-3 d-flex wrap-item-evaluation">
        <img
          class="img-evaluation"
          :src="iconUrl === 'rain' ? rainImg : sunnyImg"
        />
        <div class="pl-2 font-weight-bold">{{ titleBox }}</div>
      </div>
      <img
        src="@/assets/images/dropdown.svg"
        alt="drop"
        :class="['dropdown_icon', { 'rotate-180': isShowContent }]"
        @click="isShowContent = !isShowContent"
      />
    </div>
    <div class="p-box-content" v-show="isShowContent">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  titleBox: {
    type: String,
  },
  className: {
    type: String,
    default: '',
  },
  iconUrl: {
    type: String,
    default: '',
  },
});

const isShowContent = ref(true);
// eslint-disable-next-line
const rainImg = computed(() => require('@/assets/images/ic-rain.svg'));
// eslint-disable-next-line
const sunnyImg = computed(() => require('@/assets/images/ic-sunny.svg'));
</script>
